import { c as _c } from "react/compiler-runtime";
import StrapiImage from "@components/StrapiImage";
import { Maybe, UploadFileEntityResponse } from "@lib/generated/graphql";
import { FC, PropsWithChildren, memo } from "react";
import AnimateHeight from "react-animate-height";
const AccordionItemBody: FC<PropsWithChildren<{
  isActive: boolean;
  image?: Maybe<UploadFileEntityResponse>;
}>> = memo(function AccordionItemBody(t0) {
  const $ = _c(10);
  const {
    isActive,
    children,
    image
  } = t0;
  const t1 = isActive ? "auto" : 0;
  let t2;
  if ($[0] !== children) {
    t2 = <div className="max-w-[500px] min-w-[280px] flex-1">{children}</div>;
    $[0] = children;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== image) {
    t3 = <StrapiImage loading="lazy" width="600" height="600" image={image} className="m:hidden object-contain w-auto min-w-[280px] flex-1" />;
    $[2] = image;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <div className="w-full px-3s py-s flex flex-row flex-wrap gap-3s m:gap-3m">{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t4) {
    t5 = <AnimateHeight className="overflow-hidden transition-all duration-500" duration={300} height={t1}>{t4}</AnimateHeight>;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
});
export default AccordionItemBody;